import Vue from 'vue';

Vue.component('signature-sampler', require('./components/External/SignatureSampler.vue').default);

window.Vue = Vue;

new Vue({

	el: '#external-app',

	data: {},

	methods: {

		isMobile()
		{
			return window.innerWidth < 640;
		},

	},

});